import { useMediaQuery } from 'react-responsive';
import { AdType } from '../../constants/ads';
import AdUnit, { IPresetAdUnitProps } from './AdUnit';

const DESKTOP_AD_QUERY = {
  minWidth: 728
};

export const useIsDesktopAd = () => useMediaQuery(DESKTOP_AD_QUERY);

const CardIncAdUnit: React.FC<IPresetAdUnitProps> = props => {
  const isDesktopAd = useIsDesktopAd();

  const adCode = isDesktopAd
    ? AdType.DesktopLeaderboardInc
    : AdType.MobileBannerInc;

  return <AdUnit code={adCode} {...props} />;
};

export default CardIncAdUnit;
